var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 17.875C8.4 18.6355 7.77437 19.25 7 19.25C6.22563 19.25 5.6 18.6355 5.6 17.875C5.6 17.1145 6.22563 16.5 7 16.5C7.77437 16.5 8.4 17.1145 8.4 17.875ZM14 2.0625V19.9375C14 21.0762 13.0594 22 11.9 22H2.1C0.940625 22 0 21.0762 0 19.9375V2.0625C0 0.923828 0.940625 0 2.1 0H11.9C13.0594 0 14 0.923828 14 2.0625ZM11.9 19.6797V2.32031C11.9 2.17852 11.7819 2.0625 11.6375 2.0625H2.3625C2.21812 2.0625 2.1 2.17852 2.1 2.32031V19.6797C2.1 19.8215 2.21812 19.9375 2.3625 19.9375H11.6375C11.7819 19.9375 11.9 19.8215 11.9 19.6797Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.5bbb8ee3.svg";
export { ForwardRef as ReactComponent };